module.exports = __webpack_public_path__ + "static/media/video_3.88fbb9d2.jpg";